import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)
Vue.use(axios)

const store = new Vuex.Store({
    state: {
        apiError: false,
        specs: [],
        pages: [],
        apiUrl: 'https://kspskancelaria.pl/app/api/',
        teamMembers: [
         {name: "Katarzyna Stawiarska", description: "radca prawny, <br />wspólnik Kancelarii STAWIARSKA STALA Kancelaria Radców Prawnych spółka cywilna", image1:"/assets/katarzyna.jpg", image2:"/assets/zespol-katarzyna.jpg", link: "katarzyna-stawiarska", next: "przemyslaw-stala", prev: null},   
         {name: "Przemysław Stala", description: "radca prawny, manager sportu, <br />wspólnik Kancelarii<br />STAWIARSKA STALA Kancelaria Radców Prawnych spółka cywilna", image1:"/assets/przemyslaw.jpg", image2:"/assets/zespol-przemyslaw.jpg", link: "przemyslaw-stala", next: null, prev: "katarzyna-stawiarska"},
        ]
    },
    mutations: {
        setPages(state, payload) {
            state.pages = payload;
        },
        setSpecs(state, payload) {
            state.specs = payload;
        },
        setError(state, bool) {
            state.apiError = bool;
        }
    },
    actions: {
        async getPages({ state, commit }) {
            try {
                let response = await axios.get(`${state.apiUrl}` + 'pages')
                commit('setPages', response.data.results);
                commit('setError', false);
            } catch (error) {
                commit('setPages', []);
                commit('setError', true);
            }
        },
        async getSpecs({ state, commit }) {
            try {
                let response = await axios.get(`${state.apiUrl}` + 'topics')
                commit('setSpecs', response.data.results);
                commit('setError', false);
            } catch (error) {
                commit('setSpecs', []);
                commit('setError', true);
            }
        },
    },
    getters: {
        getPage: (state) => (url) => {
            return state.pages.find(page => page.url === url)
        },
        getSpec: (state) => (url) => {
            return state.specs.find(page => page.url_slug === url)
        },
        getMember: (state) => (name) => {
            return state.teamMembers.find(member => member.link === name)
        }
    }
});

export default store;